import { createSelector, Selector } from 'reselect'

import { SubscriptionsDetailState } from './subscriptionDetail.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetSubscriptionDetail = Selector<RootState, SubscriptionsDetailState>
const getSubscriptionDetail: GetSubscriptionDetail = (state) => state.subscriptionDetail

export const selectSubscriptionDetail = (subscriptionId: string) =>
  createSelector(
    getSubscriptionDetail,
    (subscriptionDetail) => subscriptionDetail?.[subscriptionId]?.data,
  )

export const selectSubscriptionDetailLoading = (subscriptionId: string) =>
  createSelector(
    getSubscriptionDetail,
    (subscriptionDetail) => !!subscriptionDetail?.[subscriptionId]?.loading,
  )

export const selectSubscriptionDetailError = (subscriptionId: string) =>
  createSelector(
    getSubscriptionDetail,
    (subscriptionDetail) => subscriptionDetail?.[subscriptionId]?.error,
  )
